import * as React from 'react';
import { Route, RouteProps } from 'react-router-dom';

// @ld
import useProfile from 'hooks/use-profile';
import { DocumentUploadServiceProvider } from 'components/document-upload-service';

import { PageLoader, useBreakpoints } from '@ld/core';

// @custom
import AppBar from '../app-bar';
import Sidebar from '../sidebar';
import { AppMain } from './styles';
import useAuthRedirect from './use-auth-redirect';

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const { mdUp } = useBreakpoints();
  const { profileId } = useProfile();
  return (
    <>
      {mdUp ? <Sidebar /> : <AppBar />}
      <AppMain>
        <DocumentUploadServiceProvider profileId={profileId}>
          {children}
        </DocumentUploadServiceProvider>
      </AppMain>
    </>
  );
};

const AppLayoutRoute = ({
  component: Component,
  location,
  children,
  ...rest
}: RouteProps & { children?: React.ReactNode }) => {
  useAuthRedirect({ location });
  return (
    <Route
      {...rest}
      render={(props) => (
        <AppLayout>
          <React.Suspense fallback={<PageLoader />}>
            {Component ? <Component {...props} /> : children}
          </React.Suspense>
        </AppLayout>
      )}
    />
  );
};

export default AppLayoutRoute;
